import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-50431d45")

_pushScopeId("data-v-50431d45")
const _hoisted_1 = { class: "content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "left-btn",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToAkuvox && _ctx.goToAkuvox(...args)))
    }, [
      _createVNode("img", {
        class: "img akuvox-page",
        src: require('@/assets/image/akuvox-page.png')
      }, null, 8, ["src"])
    ]),
    _createVNode("div", {
      class: "right-btn",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToAkubola && _ctx.goToAkubola(...args)))
    }, [
      _createVNode("img", {
        class: "img akubela-page",
        src: require('@/assets/image/akubela-page.png')
      }, null, 8, ["src"])
    ])
  ]))
})